import React from "react";
import "./HomeTopClient.css";
import TopClients from "./TopClients.jpg";

function HomeTopClients() {
    return (
        <section id="contact" className="clients">
            <div className="clients__container">
                <div className="section-heading">
                    <span className="section-heading__label">Trusted By The Best</span>
                    <h2 className="section-heading__title">Our Top Clients</h2>
                    <span className="section-heading__bar"></span>
                </div>

                <div className="clients__card">
                    <p className="clients__text">
                        Serving UAE's top clients since 2001.
                    </p>
                    <div className="clients__image-wrapper">
                        <img
                            src={TopClients}
                            alt="Top Clients"
                            className="clients__image"
                        />
                    </div>
                </div>
            </div>

            {/* ── Footer ── */}
            <footer className="footer">
                <div className="footer__inner">
                    <span className="footer__brand">EURO<span>LIGHT</span></span>
                    <p className="footer__copy">
                        &copy; {new Date().getFullYear()} Euro Light Trading. All rights reserved.
                    </p>
                </div>
            </footer>
        </section>
    );
}

export default HomeTopClients;